import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { returnsListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const returnsListRouteMetadata: IRouteMetadataObj<typeof returnsListRoutesObj> =
  {
    list: {
      title: "purchaseManagement.index.title",
      description: "empty",
      lazy: () => import("@pages/purchaseManagement/returnsList/table/page"),
      mode: "index",
      type: "main",
      icon: "MoneyDollarCircleLine",
      breadcrumbs: [],
      permission,
    },
    restoreGoods: {
      title: "purchaseManagement.restoreGoods.title",
      description: "empty",
      lazy: () => import("@/pages/purchaseManagement/restoreGoods/page"),
      mode: "create",
      type: "inner",
      icon: "RestartLine",
      breadcrumbs: [],
      permission,
      pageState: { noPadding: true, actionType: "back" },
    },
  };

export const purchaseReturnsListRoutes = createRoute<
  typeof returnsListRoutesObj
>(returnsListRoutesObj, returnsListRouteMetadata);
